<template>
  <sea-page title="F.A.Q." header="Pagina delle F.A.Q.">
  <!--TODO: Da adeguare con le schermate di Norma Link-->
    <v-row v-for="item in items" :key="item.id" class="mt-5">
      <v-expansion-panels class="text-h5 text--primary ml-5 mr-5" accordion>
        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ item.id }}. {{ item.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ item.description }} <br />
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div
              class="d-flex flex-column align-center"
              v-for="img in item.imgs"
              :key="img.id"
            >
              <p class="mt-2">{{ img.text }}</p>
              <div class="hidden-md-and-up">
                <v-img width="250" :src="img.url"></v-img>
              </div>
              <div class="hidden-sm-and-down">
                <v-img width="640" :src="img.urlMd"></v-img>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </sea-page>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    items: [
      {
        id: 1,
        title:
          "Come richiedere la modifica dei dati anagrafici del lavoratore o dei familiari.",
        description: "",
        imgs: [
          {
            id: 1,
            url: require("../assets/img/faq/faq1_1.png"),
            urlMd: require("../assets/img/faq/faq1_1-md.png"),
            text: 'Dal portale dipendenti, scaricare il modello dalla sezione "Documenti", in base ai dati da variare e firmarlo.',
          },
          {
            id: 2,
            url: require("../assets/img/faq/faq1_2.png"),
            urlMd: require("../assets/img/faq/faq1_2-md.png"),
            text: 'Inviare il modello compilato dal portale dipendenti, utilizzando il servizio "Richieste."',
          },
        ],
      },
      {
        id: 2,
        title: "Come scaricare, modificare e inviare un documento.",
        description: "",
        imgs: [
          {
            id: 1,
            url: require("../assets/img/faq/faq2_1.png"),
            urlMd: require("../assets/img/faq/faq2_1-md.png"),
            text: 'Dal portale dipendenti, nella sezione "Documenti", scaricare il modello da modificare.',
          },
          {
            id: 2,
            url: require("../assets/img/faq/faq2_2.png"),
            urlMd: require("../assets/img/faq/faq2_2-md.png"),
            text: 'Per inviare il modello modificato, entrare nella sezione "Richieste", inserendo la tipologia "Richieste azienda", indicare in descrizione le modifiche ed allegare il file e cliccare su "Invia".',
          },
        ],
      },
      {
        id: 3,
        title: "Come richiedere il cambio IBAN.",
        description: "",
        imgs: [
          {
            id: 1,
            url: require("../assets/img/faq/faq3_1.png"),
            urlMd: require("../assets/img/faq/faq3_1-md.png"),
            text: 'Dal portale dipendenti aprire la sezione "Documenti-ricevuti" e scaricare il "Modello cambio IBAN", effettuare le modifiche e firmarlo.',
          },
          {
            id: 2,
            url: require("../assets/img/faq/faq3_2.png"),
            urlMd: require("../assets/img/faq/faq3_2-md.png"),
            text: 'Dal portale dipendente, aprire la sezione "Richieste", inserire la Tipologia "Modifica IBAN" ed inviare la richiesta.',
          },
        ],
      },
      {
        id: 4,
        title: "Come modificare i contatti.",
        description: "",
        imgs: [
          {
            id: 1,
            url: require("../assets/img/faq/faq4_1.png"),
            urlMd: require("../assets/img/faq/faq4_1-md.png"),
            text: 'Dal portale dipendenti, aprire la sezione "Richieste", inseire la Tipologia "Modifica contatti", indicare i nuovi contatti nel campo "Testo" ed inviare la richiesta.',
          },
        ],
      },
      {
        id: 5,
        title: "Come richiedere dei documenti mancanti.",
        description: "",
        imgs: [
          {
            id: 1,
            url: require("../assets/img/faq/faq5_1.png"),
            urlMd: require("../assets/img/faq/faq5_1-md.png"),
            text: 'Dal portale dipendenti, aprire la sezione "Documenti-ricevuti" e verificare se è disponibile il modello da inviare. In caso contrario cliccare su "Qui".',
          },
          {
            id: 2,
            url: require("../assets/img/faq/faq5_2.png"),
            urlMd: require("../assets/img/faq/faq5_2-md.png"),
            text: 'Nella sezione "Richieste", selezionare il tipo "Richiesta documenti" ed inserire la descrizione del modello da ricevere nel campo "Testo". Invia tramite il pulsante "INVIA"',
          },
        ],
      },
      {
        id: 6,
        title: "Ferie, permessi, altre motivazioni e banca ore.",
        description:
          "I dati delle ferie, permessi, altre movimentazioni e banca ore specificate nella sezione dettaglio della busta paga, rappresentano i totali annui a saldo fino al mese selezionato. Nella Home, i dati delle Ferie, permessi, altre movimentazioni e banca ore, indicati all’interno dei grafici a ciambella, rappresentano i totali annui fino all’ultima busta paga ricevuta.",
        imgs: [],
      },
      {
        id: 7,
        title: "Presenze e assenze.",
        description:
          "Le presenze e assenze visualizzate nel dettaglio della busta paga, sono inerenti al mese selezionato.  Nella Home, i dati delle presenze e assenze indicati all’interno dei grafici a ciambella, sono inerenti all’ultima busta paga ricevuta.",
        imgs: [],
      },
    ],
  }),
  methods: {},
};
</script>
<style>
</style>
